import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationCard } from 'src/app/model/interfaces/navigation-card';
import { ContentService } from 'src/app/services/content.service';

@Component({
    selector: 'app-navigation-cards',
    templateUrl: './navigation-cards.component.html',
    styleUrls: ['./navigation-cards.component.scss']
})
export class NavigationCardsComponent implements OnInit
{
    @Input('currentRoute') public currentRoute: string;

    public navigationCards: NavigationCard[];

    private router: Router;
    private readonly contentService: ContentService;

    public constructor(router: Router, contentService: ContentService)
    {
        this.router = router;
        this.contentService = contentService;
    }

    public ngOnInit(): void
    {
        this.getNavigationCardContent();
    }

    public getNavigationCardContent(): void
    {
        this.navigationCards = this.contentService.getNavigationCardContent();
        this.navigationCards = this.navigationCards.filter((item) => {
            return item.Url !== this.currentRoute;
        });
    }

    public onNavigateToPageClick(path: string): void
    {
        this.router.navigateByUrl(path);
        this.getNavigationCardContent();
    }
}
